import React from 'react';
import './RoomToggle.scss';

interface Props {
  mode: 'preconfigured' | 'custom';
  onChange: (mode: 'preconfigured' | 'custom') => void;
}

const RoomToggle: React.FC<Props> = ({ mode, onChange }) => (
  <div className="room_toggle_container">
    <button
      type="button"
      className={`toggle_option ${mode === 'preconfigured' ? 'is_active' : ''}`}
      onClick={() => onChange('preconfigured')}
    >
      Preconfigured Room
    </button>
    <button
      type="button"
      className={`toggle_option ${mode === 'custom' ? 'is_active' : ''}`}
      onClick={() => onChange('custom')}
    >
      Custom Room
    </button>
  </div>
);

export default RoomToggle;